import { Subject, Observable, Observer } from "rxjs";
import { Injectable } from "@angular/core";
import { CommonService } from "../common/common.service";
import { Plugins, AppState, PluginListenerHandle } from "@capacitor/core";

@Injectable()
export class MobileService implements CommonService {
	private subscriptionAppState: PluginListenerHandle = null;
	private subscriptionBackButton: PluginListenerHandle = null;

	public appState$: Subject<AppState> = new Subject();
	public backButton$: Observable<void>;

	intinialize() {
		this.subscriptionAppState = Plugins.App.addListener(
			"appStateChange",
			(state: AppState) => {
				this.appState$.next(state);
			}
		);
	}

	public overrideBackbutton(): Observable<void> {
		let observer: Observer<void> = null;
		const btn$ = new Observable<void>((obs) => { observer = obs});
		this.subscriptionBackButton = Plugins.App.addListener(
			"backButton",
			() => {
				if (observer) {
					observer.next();
				}
			}
		);
		return btn$;
	}

	public clearAllEvents() {
		this.subscriptionAppState.remove();

		this.appState$.complete();
	}
}
